import { useEffect, useRef, useCallback } from 'react';

// Récupération de la durée (par défaut 30 secondes)
const timeoutSeconds = process.env.REACT_APP_INACTIVITY_TIMEOUT_SECONDS || 30;
const INACTIVITY_TIMEOUT = parseInt(timeoutSeconds) * 1000;

const useInactivityMonitor = (onTimeout) => {
    const timeoutRef = useRef(null);
    const onTimeoutRef = useRef(onTimeout);

    useEffect(() => {
        onTimeoutRef.current = onTimeout;
    }, [onTimeout]);

    const resetTimer = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            if (onTimeoutRef.current) onTimeoutRef.current();
        }, INACTIVITY_TIMEOUT);
    }, []);

    useEffect(() => {
        const handleActivity = () => resetTimer();

        // Ajout de 'touchstart' pour les écrans tactiles du kiosque
        const events = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll'];

        resetTimer();
        events.forEach(event => window.addEventListener(event, handleActivity));

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            events.forEach(event => window.removeEventListener(event, handleActivity));
        };
    }, [resetTimer]);
};

export default useInactivityMonitor;
